import React, { useEffect } from 'react';
import trackEvent from '../../utils/trackEvent';
import Rimg from '../Rimg.jsx';

// Add this helper function at the top
const decodeHtmlEntities = (text) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

export default function Result(props) {
  const { product, recommendedSize, hasWideWidth, widthOption, recommendedWidth, recommendedVariant, setRecommendedVariant } = props;
  const strings = window.themeStrings || {};
  
  let image = null;
  const imageIndex = Math.min(2, product.media.length) - 1;
  if (~imageIndex) {
    image = product.media[imageIndex].preview_image;
  }

  useEffect(() => {
    const findVariant = (size) => {
      return product.variants.find(v => {
        if (hasWideWidth) {
          return v.options.includes(recommendedWidth) && v.options.includes(`${size}`)
        }
        return v.options.includes(`${size}`)
      })
    }

    let quizProfile = product.tags.find(tag => tag.startsWith('fqv2:'));
    if (quizProfile) {
      quizProfile = quizProfile.replace('fqv2:', '');
    }

    let tempVariant = findVariant(recommendedSize);

    if (!tempVariant) {
      const adjustments = [-0.5, 0.5, -1, 1];
      for (let i = 0; i < adjustments.length; i++) {
        const size = parseFloat(recommendedSize) + adjustments[i];
        tempVariant = findVariant(size);
        if (tempVariant) {
          break;
        }
      }
    }

    if (tempVariant) {
      setRecommendedVariant(tempVariant);
      trackEvent('Fit Finder Results', { handle: product.handle, vendor: product.vendor, quizProfile, variantName: tempVariant.title, sku: tempVariant.sku });
    }
  }, [recommendedWidth, recommendedSize])

  const RecommendationBody = () => {
    const isNonUSCountry = window.Theme && window.Theme.localizationCountry && window.Theme.localizationCountry !== 'US';
    
    if (recommendedSize) {
      if (recommendedVariant.id) {
        if (recommendedVariant.available) {
          const sizeDisplay = isNonUSCountry ? `${recommendedVariant.title} (US)` : recommendedVariant.title;
          return (
            <React.Fragment>
              <p className="text1">{strings.fit_finder_result_recommend_order}</p>
              <h1 className="recommended-size">{sizeDisplay}</h1>
              <p className="text2">{strings.fit_finder_result_in_the.replace('{product}', product.title)}</p>
            </React.Fragment>
          )
        } else {
          const message = product.tags.includes('BIS') 
            ? strings.fit_finder_result_size_popular_in_stock 
            : strings.fit_finder_result_size_popular_no_stock;
          return (
            <p className="text1">{message.replace('{size}', recommendedVariant.title)}</p>
          )
        }
      } else {
        const sizeText = recommendedWidth ? `${recommendedWidth} ${recommendedSize}` : recommendedSize;
        return (
          <p className="text1">{strings.fit_finder_result_not_carry_size.replace('{size}', sizeText)}</p>
        )
      }
    } else {
      return (
        <p className="text1">{strings.fit_finder_result_unable_recommend}</p>
      )
    }
  }

  return (
    <div className="form-body">
      {image && <Rimg src={image.src} width={image.width} height={image.height} minWidth={288} sizes="288px" loading="lazy" className="ff-image" />}
      <RecommendationBody />
      <p className="ff-tooltip" dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(strings.fit_finder_result_prefer_second_opinion || '') }} />
    </div>
  )
}